export const LANGUAGES = {
    pt: {
        urlLang: 'pt',
        code: 'pt-BR'
    },
    en: {
        urlLang: 'en',
        code: 'en-US'
    },
    es: {
        urlLang: 'es',
        code: 'es-ES'
    },
    default: 'en'
}

export const LanguagesList = [
    {
        code: 'en',
        name: 'English'
    },
    {
        code: 'pt',
        name: 'Português'
    },        
    {
        code: 'es',
        name: 'Español'
    }
]